import React from 'react';
import clientImg from '../img/client.jpg'
import JointCommission from './JointCommission';

function Nurses() {
  return (
    <>
    <div className="breadcrumb-area gradient-bg bg-cover shadow dark text-light text-center" style={{backgroundImage: `url(${clientImg})`}}>
        <div className="container">
            <div className="row">
                <div className="col-lg-8 offset-lg-2">
                    <h1>Employee Information</h1>
                    <ul className="breadcrumb">
                        <li><a href="/"><i className="fas fa-home"></i> Home</a></li>
                        <li className="active">EMPLOYEES</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div className="blog-area single full-blog right-sidebar default-padding">
        <div className="container">
            <div className="blog-items">
                <div className="row">
                    <div className="blog-content col-lg-8 col-md-12">
                        
                        <div className="single-item">

                            <div className="blog-item-box">
                                <div className="item">
                                    <div className="info">
                                        
                                        <p>
                                            If you are looking for a flexible Per Diem, contract, or travel opportunities, Divine CHP Staffing is the best staffing agency for you. We value our employees and respect their experience, hard work and commitment. We treat our  employees with dignity and respect. We are always adding more professional employees in different areas of medical field.
                                        </p>
                                        
                                        <blockquote>
                                            Are you looking for a flexible per Diem, contract or travel  opportunity? turn to us.
                                        </blockquote>
                                        
                                        <h5><i><b>Our employment requirements:</b></i></h5>

										<ul>Online Application
											<li>Valid license and certificate</li>
											<li>Competency Test</li>
											<li>State issued ID ( SSN and Driver license)</li>
											<li>Interview</li>
											<li>Current TB test or negative chest X-ray exam</li>
											<li>Immunizations (MMR, Varicella, Tdap, Hep B). Tdap has to be less than ten years. MMR and Varicella Titer has to be positive( immunity)</li>
											<li>ACLS (CNAs are not required to have this certification)</li>
											<li>BLS certification ( Must come from American Heart Association or American Red cross)
											Background check</li>
											<li>Drug screening</li>
											<li>Three verifiable references</li>
											<li>At least six month of experience is required in the indicated field.</li>					   
                                        </ul>

                                       <p> Our company (e-verify) all applicants for employment eligibility.</p>
                                       <p> If you need more informations on any of our processes, please feel free to <a href="contact">contact us</a> at 919 972 1964. </p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="sidebar col-lg-4 col-md-12">
                        <aside>
                            <JointCommission />
                        </aside>
                    </div>

                </div>
            </div>
        </div>
    </div>
    </>
  );
}

export default Nurses;